var map = {
	"../purchase/order/order.module": [
		"Kz0N",
		26
	],
	"./appointments/appointments.module": [
		"Yyjs",
		3
	],
	"./companies/companies.module": [
		"D+Rg"
	],
	"./coupons/coupons.module": [
		"+aBN",
		4
	],
	"./crud/order.module": [
		"xnkN",
		5
	],
	"./deliver-my-medicines/deliver-my-medicines.module": [
		"x9hi",
		6
	],
	"./dhome/dhome.module": [
		"gpI9",
		7
	],
	"./disbursement/disbursement.module": [
		"tKxO",
		8
	],
	"./doctors/doctors.module": [
		"D90y",
		9
	],
	"./feedbacks/feedbacks.module": [
		"0ulC"
	],
	"./fees-addons/fees-addons.module": [
		"ZnNi",
		1,
		10
	],
	"./fees/fees.module": [
		"8ZKP",
		11
	],
	"./generic-names/generic-names.module": [
		"4RsF"
	],
	"./home/home.module": [
		"ZAPo"
	],
	"./manage-clinics/manage-clinics.module": [
		"zBPU",
		2
	],
	"./manage-secretary/manage-secretary.module": [
		"JXCi",
		13
	],
	"./medical-practitioners/medical-practitioners.module": [
		"Pjcw",
		14
	],
	"./medicines/medicines.module": [
		"gZRp"
	],
	"./messages/messages.module": [
		"nZYT"
	],
	"./my-account/my-account.module": [
		"ZG09",
		2,
		15
	],
	"./my-prescription/my-prescription.module": [
		"FUMm",
		16
	],
	"./ordera/order-addons.module": [
		"97Fc",
		1,
		17
	],
	"./ordera/order.module": [
		"EgV1",
		18
	],
	"./orders/orders.module": [
		"b/xR"
	],
	"./other-files/other-files.module": [
		"jkBy",
		19
	],
	"./pages/calendar/calendar.module": [
		"GHmx",
		20
	],
	"./pages/find-doctors/find-doctors.module": [
		"TjYQ",
		21
	],
	"./pages/search/search.module": [
		"7r8L",
		22
	],
	"./patients/patients.module": [
		"V477",
		23
	],
	"./purchase/purchase.module": [
		"nf0w",
		27
	],
	"./roles/roles.module": [
		"0upZ"
	],
	"./staffs/staffs.module": [
		"3aFd",
		28
	],
	"./status/status.module": [
		"SANq",
		29
	],
	"./users/users.module": [
		"kQgB"
	],
	"./verify-email/verify-email.module": [
		"RtZn",
		32
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "zn8P";
module.exports = webpackAsyncContext;